export default function Select({ options = [], children, className = '', ...props }) {
  return (
    <select className={`input-base ${className}`} {...props}>
      {children || options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

